var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirectMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410086639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 300"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.2227,
    width: 55.0789,
    height: 99.6667,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2227,
    y: 1,
    width: 53.0789,
    height: 97.6667,
    rx: 7,
    stroke: "#B9DDFF",
    strokeOpacity: 0.7,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 301",
    x: 27.4707,
    y: 5.24566,
    width: 44.5877,
    height: 89.1754,
    rx: 6,
    fill: "#5283EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 891",
    d: "M43 49.5L47.5 54L58.5 43",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624323",
    x: 43.2051,
    y: 13.114,
    width: 13.114,
    height: 2.62281,
    rx: 1.3114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectMob);
export default __webpack_public_path__ + "static/media/redirect-mob.f40ef995a45757868a602bea0f002681.svg";
export { ForwardRef as ReactComponent };